import React from 'react';
import { IndexRoute, Route } from 'react-router';

import {
  LoadablePage,
  LoadableLabsPage,
  LoadableSocialPage,
} from './helpers/loadables';

const LabsRoutes = (
  <Route path="labs" component={LoadablePage}>
    <IndexRoute component={LoadableLabsPage} />
    <Route path="social" component={LoadableSocialPage} />
  </Route>
);

export default LabsRoutes;
